const DEFAULT_SETTINGS = {
  /*
  fieldId: { // Same ID as supplied to <Input />
    value: '',
    defaultValue: '', // Update StepReview.jsx & relevant step(s) if you need to output
  }
  */

  /* Default Advanced Settings */
  batchSize: {
    defaultValue: '10000',
  },
  throttleEnabled: {
    value: false, // We want to default to true on render, but never compare the default
  },
  selectAllLogTypes: {
    value: false,
  },
  subscribeToAllLog: {
    value: true, // We want to default to true on render, but never compare the default
  },

  salesforceName: {
    value: '',
  },

  salesforceThrottleEnabled: {
    value: undefined,
  },
  accessTokenExpiresIn: {
    value: 1,
  },
  pollingInterval: {
    value: 5,
  },

  availableContents: {
    value: '',
  },

  logTypes: {
    value: '',
  },

};

export default DEFAULT_SETTINGS;
